/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResetPasswordResponse {
    getFixupPrototypeFunction() { return ResetPasswordResponse.fixupPrototype; }

    static newInstance(model: Partial<ResetPasswordResponse>): ResetPasswordResponse {
        let obj = Object.assign(new ResetPasswordResponse(), model);
        ResetPasswordResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResetPasswordResponse>): ResetPasswordResponse {
        if (!model) return null;
        return ResetPasswordResponse.newInstance(<ResetPasswordResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResetPasswordResponse) {
        if (!obj) return;

        models.ResetPasswordResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResetPasswordResponse): boolean {
        Object.setPrototypeOf(obj, ResetPasswordResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Status of Reset Password API call.
     */
    status: string;

    /**
     * Message of reset Password API call.
     */
    message: string;

    /**
     * Link for Reset Password
     */
    data: string;

}
